import { ITLOrganizationSubscriptionPricingTierModel } from '../../../../models/interfaces/Subscription/TravelLicense/ITLOrganizationSubscriptionPricingTierModel';

export const TLSubscriptionDefaultValue: ITLOrganizationSubscriptionPricingTierModel =
  { seatsAmount: 0, price: 0 };
export const TLSubscriptionDefaultValueArray = [TLSubscriptionDefaultValue];
